import React from 'react';

import { T } from 'react-translator-component';

import { UnknownOcppTag } from '../../../types/responses/UnknownOcppTags';

const MPT = ['Sem nome', T('Undefined'), T('Does not own')];

const innerDataFormater = (unknownTag: UnknownOcppTag) => {
  return {
    key: unknownTag.key,
    numberOfAttempts: unknownTag.numberOfAttempts,
    lastAttemptTimestampHumanReadable: unknownTag.lastAttemptTimestampHumanReadable,
    chargeBoxID: unknownTag.chargeBoxID,
    tenantPk: unknownTag.tenantPk,
    tenantName: unknownTag.tenantName,
  };
};

const listFormater = (list: UnknownOcppTag[]) => {
  let cardsList: any = [];
  let innerData: any = [];
  list !== undefined &&
    list.forEach((unknownTag) => {
      cardsList = [
        ...cardsList,
        [
          {
            value: unknownTag.key?.length > 25 ? unknownTag.key.substring(0, 25) + '...' : unknownTag.key || MPT[2],
            subValue: '',
            icon: <></>,
            size: '30%',
          },
          { value: unknownTag.numberOfAttempts || T(MPT[2]), subValue: '', icon: <></>, size: '10%' },
          { value: unknownTag.lastAttemptTimestampHumanReadable || T(MPT[2]), subValue: '', icon: <></>, size: '15%' },
          {
            value:
              unknownTag.tenantName?.length > 25
                ? unknownTag.tenantName.substring(0, 20) + '...'
                : unknownTag.tenantName || MPT[2],
            subValue: '',
            icon: <></>,
            size: '15%',
          },
          {
            value:
              unknownTag.chargeBoxID?.length > 25
                ? unknownTag.chargeBoxID.substring(0, 25) + '...'
                : unknownTag.chargeBoxID || MPT[2],
            subValue: '',
            icon: <></>,
            size: '15%',
            align: 'center',
          },
        ],
      ];

      innerData = [...innerData, innerDataFormater(unknownTag)];
    });

  return { cardsList, innerData };
};

export const combiningObjects = (list: UnknownOcppTag[], header) => {
  return {
    header,
    ...listFormater(list),
  };
};
